<template>
  <div v-if="showing" class="spinner">
    <div class="msg">Cargando datos ...</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showing: false
    };
  },
  mounted() {
    let vm = this;
    this.$eventBus.$on("spinner-on", function() {
      vm.showing = true;
    });

    this.$eventBus.$on("spinner-off", function() {
      vm.showing = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.spinner {
  background: rgba(0, 0, 0, 0.6);
  padding: 0.75rem;
  position: fixed;
  bottom: 0.5rem;
  left: 25%;
  z-index: 9998;
  border-radius: 5px;
}
.msg {
  color: white;
}
</style>
